import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { InfoOutline } from '@yme/assets/icons';
import { ICON_SIZE, SVGIcon } from '@yme/atoms/svg-icon';
import { useWindowSize } from '@yme/common/hooks';
import { getHeaderStickyMenuShown } from '@yme/components/Header/redux/selectors';
import { COMPATIBILITY_ANCHOR } from '@yme/pdp-components/DescriptionFaq/constants';
import { getProductCardLabels, getSelectedCompatibilityProduct, } from '@yme/pdp-components/ProductCard';
import { CheckCompatibilityLink } from '@yme/pdp-components/ProductCard/CardAccessories/CheckCompatibilityLink';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { RegularTextLevel3 } from '@yme/tokens/typography';
import { getOffsetForScrollTo, scrollToId } from '@yme/utils/common';
import { getPLPLinkWithAccessoriesAndApparels } from '@yme/utils/product';
export function CheckCompatibility(props) {
    const { onClickHandler, alertText, linkLabel, isRightToLeft, link } = props;
    const headerStickyMenuShown = useSelector(getHeaderStickyMenuShown);
    const { isMobileView } = useWindowSize();
    const selectedCompatibilityProduct = useSelector(getSelectedCompatibilityProduct);
    const product = selectedCompatibilityProduct?.product;
    const finallyLink = getPLPLinkWithAccessoriesAndApparels(link, product?.key);
    const yOffset = getOffsetForScrollTo({
        isMobileView,
        headerStickyMenuShown,
    });
    const { partsAccessoriesMerch_checkCompatibilityAlert_description: checkCompatibilityAlert, partsAccessoriesMerch_checkCompatibility_link: checkCompatibilityLabel, } = useSelector(getProductCardLabels);
    const onButtonClick = useCallback(() => {
        if (onClickHandler) {
            onClickHandler();
        }
        if (linkLabel) {
            scrollToId({
                id: COMPATIBILITY_ANCHOR,
                yOffset: yOffset || 0,
            });
        }
    }, [onClickHandler, linkLabel, yOffset]);
    return (React.createElement(FlexWrapper, { isRightToLeft: isRightToLeft, flexDirection: isMobileView ? 'column' : undefined, justifyContent: "space-between", gap: "8px", isFullWidth: true },
        React.createElement(FlexWrapper, { alignItems: "center", gap: "9px" },
            React.createElement(FlexWrapper, { alignSelf: "flex-start", mt: "3px" },
                React.createElement(SVGIcon, { type: InfoOutline, pathFill: colorCoreBlack900Base, size: ICON_SIZE.xs })),
            React.createElement(RegularTextLevel3, { color: colorCoreBlack900Base }, alertText || checkCompatibilityAlert)),
        React.createElement(CheckCompatibilityLink, { link: finallyLink, linkLabel: linkLabel, onClickHandler: onButtonClick, checkCompatibilityLabel: checkCompatibilityLabel })));
}
